 //  SMS POPUP
//import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Component,  OnInit,  Input,  Output,  EventEmitter,  ViewChild,} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";


import { Router, ActivatedRoute } from "@angular/router";
import { ItemModifierService } from "src/app/ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../store/userInfo.store";

@Component({
  selector: 'app-pro-tile',
  templateUrl: './pro-tile.component.html',
  styleUrls: ['./pro-tile.component.scss']
})
export class ProTileComponent implements OnInit {

  @Input() productImgURL1: string = "../../../assets/styles/images/books/1.jpg";
  @Input() productImgURL2: string = "../../../assets/styles/images/books/1.jpg";
  @Input() hotLabel: string = "BEST SALLER";
  @Input() productURL: string = "#/single-product";

 // @Input() productURL: string = "https://hideandskin.in/#/single-product/718&MA%201%20BRN%20PALE";
  @Input() productName: string = "robin parrish";
  @Input() currentPrize: string = "$35.00";
  @Input() oldPrize: string = "$35.00";
  @Input() saveAmount: string = "$00.00";
  @Input() savePercent: string = "$0.00";
  @Input() itemId: string = "1";
  @Input() sku: string = "1";
  @Input() collectionName: string = "None";

  @Output() quickView = new EventEmitter<string>();

  //  SMS POPUP
  @ViewChild("content") view;
  SMS: string;



  constructor
  (

    private route: ActivatedRoute,
    private router: Router,
    private itemModifierService: ItemModifierService,
    private infoStore: UserInfoStore,

     //  SMS POPUP
    private modalService: NgbModal

  ) { }

  ngOnInit(): void {
  }

  routeSingle(itemId, sku) {
    this.router.navigateByUrl("/single-product/" + itemId + "&" + sku);
    //this.router.navigateByUrl("https://member5.smarterasp.net/cp/cp_screen");
  }

   //  SMS POPUP
   open() {
    const modalRef = this.modalService.open(this.view);
  }

  openQuickView(sku, collectionName) {
    this.quickView.emit(sku + "&" + collectionName);
  }


  addToCart() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: 0,
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
        ApplicationItemCategoryId: 4,
        OrderStatusID: 2,
        OrderShippingCategoryID: 0,
        OrderPaymentTypeId: 0,
        PackingId: 0,
        TrackId: 0,
        SKUCode: this.sku,
        Qty: 1,
        CreatedBy: 55,
        Notes:null,
        OperationType: "insert",
      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);
          if (event[0].OperationStatus == "Successfully Saved") {
               //alert("Add To Cart Successfully !");

             //this.SMS="Add To Cart Successfully !";
            //this.open();
            this.getCartInfo();
          }
        }
      });
    } else {
      // alert("Please Login");
      this.SMS="Please Login";
      this.open();
      this.router.navigateByUrl("login");
    }
  }

  addToWishlist() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: 0,
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
        ApplicationItemCategoryId: 3,
        OrderStatusID: 2,
        OrderShippingCategoryID: 0,
        OrderPaymentTypeId: 0,
        PackingId: 0,
        TrackId: 0,
        SKUCode: this.sku,
        Qty: 1,
        CreatedBy: 55,
        Notes:null,
        OperationType: "insert",
      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);
          if (event[0].OperationStatus == "Successfully Saved") {
            //alert("Add To WishList Successfully !");

           // this.SMS="Add To WishList Successfully !";
          //  this.open();

          }
        }
      });
    } else {
      //alert("Please Login");
      this.SMS="Please Login";
      this.open();
      this.router.navigateByUrl("login");

    }
  }

  getCartInfo() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.infoStore.setCartInfo(event);
          } else {
            this.infoStore.setCartInfo([]);
          }
        });
    } else {
      this.infoStore.setCartInfo([]);
    }
  }








}
